"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRouterMiddleware = void 0;
var actions_1 = require("../constants/actions");
var createRouterMiddleware = function (history) {
    return function () {
        return function (next) {
            return function (action) {
                if (action.type === actions_1.CALL_HISTORY_METHOD) {
                    var _a = action.values, method = _a.method, location_1 = _a.location;
                    if (method === 'goBack') {
                        history.back();
                    }
                    else if (location_1) {
                        history[method](location_1);
                    }
                }
                return next(action);
            };
        };
    };
};
exports.createRouterMiddleware = createRouterMiddleware;
